/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".selects[_ngcontent-%COMP%]{display:flex}.selects[_ngcontent-%COMP%]    >*{width:calc(50% - .5rem)}.selects[_ngcontent-%COMP%]    >:nth-child(3){margin-left:1rem}[_nghost-%COMP%]     ndc-dynamic{display:none}"];
export { styles as styles };
